import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Form, Pagination, InputGroup, Modal } from 'react-bootstrap';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import axios from 'axios';
import { BsPencilSquare, BsTrash, BsSearch, BsSortDown, BsSortUp, BsPlus } from 'react-icons/bs';
import { API_ENDPOINTS } from '../config';

const MentalHealthVideos = () => {
  const [videos, setVideos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [videosPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('videoId');
  const [sortDirection, setSortDirection] = useState('asc');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [newVideo, setNewVideo] = useState({
    title: '',
    description: '',
    videoId: '',
    videoType: 'Breathing Exercise', // default to the first enum option
    thumbnail: '',
    videoLink: ''
  });
  const [currentEditVideo, setCurrentEditVideo] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null); // New state for thumbnail file

  useEffect(() => {
    fetchVideos();
  }, []);

  const fetchVideos = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.getAllMentalHealthVideos, {
        headers: {
          'token': localStorage.getItem('token'),
        }
      });
      setVideos(response.data);
    } catch (error) {
      console.error('Error fetching videos:', error);
    }
  };

  const sortVideos = (field) => {
    if (field === sortField) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortedAndFilteredVideos = videos
    .filter(video =>
      video.title.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (a[sortField] < b[sortField]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortField] > b[sortField]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

  const indexOfLastVideo = currentPage * videosPerPage;
  const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
  const currentVideos = sortedAndFilteredVideos.slice(indexOfFirstVideo, indexOfLastVideo);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleEdit = (video) => {
    setCurrentEditVideo(video);
    setShowEditModal(true);
  };

  const handleDelete = async (videoId) => {
    try {
      await axios.delete(API_ENDPOINTS.deleteMentalHealthVideo, {
        headers: {
          'token': localStorage.getItem('token'),
          'videoid': videoId
        }
      });
      setVideos(videos.filter(video => video.videoId !== videoId));
    } catch (error) {
      console.error('Error deleting video:', error);
    }
  };

  const handleAddVideo = async () => {
    const formData = new FormData();
    formData.append('title', newVideo.title);
    formData.append('description', newVideo.description);
    formData.append('videoId', newVideo.videoId);
    formData.append('videoType', newVideo.videoType);
    formData.append('videoLink', newVideo.videoLink);

    if (thumbnailFile) {
      formData.append('thumbnail', thumbnailFile);
    } else {
      formData.append('thumbnail', newVideo.thumbnail); // Fallback if no file is selected
    }

    try {
      await axios.post(API_ENDPOINTS.addMentalHealthVideo, formData, {
        headers: {
          'token': localStorage.getItem('token'),
          'Content-Type': 'multipart/form-data'
        }
      });
      setShowAddModal(false);
      fetchVideos(); // Refresh the list after adding a new video
    } catch (error) {
      console.error('Error adding video:', error);
    }
  };

  const handleEditVideo = async () => {
    const formData = new FormData();

    formData.append('title', currentEditVideo.title);
    formData.append('description', currentEditVideo.description);
    formData.append('videoId', currentEditVideo.videoId);
    formData.append('videoType', currentEditVideo.videoType);
    formData.append('videoLink', currentEditVideo.videoLink);
   
    if (thumbnailFile) {
      formData.append('thumbnail', thumbnailFile);
    } else {
      formData.append('thumbnail', currentEditVideo.thumbnail); // Fallback if no file is selected
    }

    try {
      await axios.patch(`${API_ENDPOINTS.updateMentalHealthVideo}`, formData, {
        
        headers: {
          'Content-Type': 'multipart/form-data',
          'token': localStorage.getItem('token'),
          'videoId': currentEditVideo._id
        }
      });
      setShowEditModal(false);
      fetchVideos(); // Refresh the list after editing the video
    } catch (error) {
      console.error('Error editing video:', error);
    }
  }; 

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (showAddModal) {
      setNewVideo({ ...newVideo, [name]: value });
    } else if (showEditModal) {
      setCurrentEditVideo({ ...currentEditVideo, [name]: value });
    }
  };

  const handleFileChange = (e) => {
  
     if (showAddModal) {
      setThumbnailFile(e.target.files[0]);
    } else if (showEditModal) {
      setThumbnailFile(e.target.files[0]);
      
    } 
    
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: '100vh' }}>
      <Sidebar style={{ position: 'fixed', top: 0, bottom: 0, left: 0, width: '250px', zIndex: 1000 }} />
      <div className="w-100">
        <Header style={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1000 }} />
        <Container fluid className="mt-3">
          <Row>
            <Col>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h2>Mental Health Videos</h2>
                <Button variant="primary" onClick={() => setShowAddModal(true)}>
                  <BsPlus /> Add Video
                </Button>
              </div>
              <InputGroup className="mb-3">
                <InputGroup.Text><BsSearch /></InputGroup.Text>
                <Form.Control
                  placeholder="Search videos..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
              <Table striped bordered hover responsive>
           
                <thead>
                  <tr>
                    <th onClick={() => sortVideos('videoId')}>
                      Video ID {sortField === 'videoId' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortVideos('title')}>
                      Title {sortField === 'title' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th>Description</th>
                    <th onClick={() => sortVideos('videoType')}>
                      Video Type {sortField === 'videoType' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th>Thumbnail</th>
                    <th>Video Link</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentVideos.map((video) => (
                    <tr key={video.videoId}>
                      <td>{video.videoId}</td>
                      <td>{video.title}</td>
                      <td style={{ maxWidth: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {video.description}
                      </td>
                      <td>{video.videoType}</td>
                      <td>
                        {video.thumbnail && (
                          <img
                            src={video.thumbnail}
                            alt={video.title}
                            style={{ width: '100px', height: 'auto', objectFit: 'cover' }}
                          />
                        )}
                      </td>
                      <td>{video.videoLink}</td>
                      <td className="d-flex align-items-center">
                        <Button variant="info" className="me-2" onClick={() => handleEdit(video)}>
                          <BsPencilSquare />
                        </Button>
                        <Button variant="danger" onClick={() => handleDelete(video.videoId)}>
                          <BsTrash />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Pagination>
                {[...Array(Math.ceil(sortedAndFilteredVideos.length / videosPerPage))].map((_, index) => (
                  <Pagination.Item key={index + 1} active={index + 1 === currentPage} onClick={() => paginate(index + 1)}>
                    {index + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </Col>
          </Row>
        </Container>

        {/* Add Video Modal */}
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Video</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formVideoTitle">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter video title"
                  name="title"
                  value={newVideo.title}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="formVideoDescription">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter video description"
                  name="description"
                  value={newVideo.description}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="formVideoType">
                <Form.Label>Video Type</Form.Label>
                <Form.Control
                  as="select"
                  name="videoType"
                  value={newVideo.videoType}
                  onChange={handleInputChange}
                >
                  <option>Breathing Exercise</option>
                  <option>Meditation</option>
                  <option>Life Coach Sessions</option>
                  <option>Therapist Sessions</option>
                  <option>Dr. Nada Munshi Podcast</option>
                  <option>Therapeutic Sessions</option>
                  <option>Education</option>
                  <option>Mindfulness Sessions</option>
                  <option>Sex Intimacy Sessions</option>
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formVideoLink">
                <Form.Label>Video Link</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter video link"
                  name="videoLink"
                  value={newVideo.videoLink}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="formThumbnail">
                <Form.Label>Thumbnail</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleAddVideo}>
              Add Video
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Video Modal */}
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Video</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formEditVideoTitle">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter video title"
                  name="title"
                  value={currentEditVideo?.title || ''}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="formEditVideoDescription">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter video description"
                  name="description"
                  value={currentEditVideo?.description || ''}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="formEditVideoType">
                <Form.Label>Video Type</Form.Label>
                <Form.Control
                  as="select"
                  name="videoType"
                  value={currentEditVideo?.videoType || ''}
                  onChange={handleInputChange}
                >
                  <option>Breathing Exercise</option>
                  <option>Meditation</option>
                  <option>Life Coach Sessions</option>
                  <option>Therapist Sessions</option>
                  <option>Dr. Nada Munshi Podcast</option>
                  <option>Therapeutic Sessions</option>
                  <option>Education</option>
                </Form.Control>
              </Form.Group>
              <Form.Group controlId="formEditVideoLink">
                <Form.Label>Video Link</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter video link"
                  name="videoLink"
                  value={currentEditVideo?.videoLink || ''}
                  onChange={handleInputChange}
                />
              </Form.Group>
              <Form.Group controlId="formEditThumbnail">
                <Form.Label>Thumbnail</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={handleFileChange}
                />
                {currentEditVideo?.thumbnail && !thumbnailFile && (
                  <img
                    src={currentEditVideo.thumbnail}
                    alt={currentEditVideo.title}
                    style={{ width: '100px', height: 'auto', objectFit: 'cover', marginTop: '10px' }}
                  />
                )}
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Close
            </Button>
            <Button variant="primary" onClick={handleEditVideo}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default MentalHealthVideos;
